import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Scrolls to the top of the page on every route change.
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
    
    // Tiny delay to handle lazy-loaded layout shifts and Suspense transitions
    const timer = setTimeout(() => {
      window.scrollTo(0, 0)
    }, 50)
    
    return () => clearTimeout(timer)
  }, [pathname])

  return null
}
